import { render } from "./ym-edit.vue?vue&type=template&id=35fa267a"
import script from "./ym-edit.vue?vue&type=script&lang=js"
export * from "./ym-edit.vue?vue&type=script&lang=js"

import "./ym-edit.vue?vue&type=style&index=0&id=35fa267a&lang=css"

import exportComponent from "/workspace/251623126/emo-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__